import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IO365CopilotUsage,
  ISearch,
} from '../../../services/o365/o365-copilot-usage/o365-copilot-usage.model';
import o365CopilotUsageService from '../../../services/o365/o365-copilot-usage/o365-copilot-usage.service';

export const searchO365CopilotUsage = createAsyncThunk(
  'searchO365CopilotUsage',
  async (searchParam?: ISearch) => {
    const response = await o365CopilotUsageService.searchO365CopilotUsage(searchParam).then((res) => {
      return res.body;
    });
    return response.data;
  }
);

export const getO365CopilotUsageById = createAsyncThunk(
  'getO365CopilotUsageById',
  async (id: number) => {
    const response = await o365CopilotUsageService.getO365CopilotUsageById(id).then((res) => {
      return res.body;
    });
    return response.data;
  }
);

export const saveO365CopilotUsage = createAsyncThunk(
  'saveO365CopilotUsage',
  async (data: IO365CopilotUsage) => {
    const response = await o365CopilotUsageService.saveO365CopilotUsage(data).then((res) => {
      return res.body;
    });
    return response;
  }
);

export const deleteO365CopilotUsage = createAsyncThunk(
  'deleteO365CopilotUsage',
  async (id: number) => {
    const response = await o365CopilotUsageService.deleteO365CopilotUsage(id).then((res) => {
      return res.body;
    });
    return response;
  }
);
